package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import com.jingfangpai.common.orm.mapping.enums.FileEntityType
import kotlin.String
import com.jingfangpai.common.orm.mapping.enums.FileType
import com.jingfangpai.common.orm.mapping.File
import com.jingfangpai.file.model.CkEditorFileUploadResponse

object FileApiClient :BaseServiceClient() {

	@JsName("getByEntityAndType")
	fun getByEntityAndType(entityType:com.jingfangpai.common.orm.mapping.enums.FileEntityType?,entityId:kotlin.String?,type:com.jingfangpai.common.orm.mapping.enums.FileType?, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.File>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"entityType" to "${entityType?:""}",
			"entityId" to "${entityId?:""}",
			"type" to "${type?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.File>> = httpClient.get {
				    url("/api/file/getByEntityAndType?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("removeByIdAndName")
	fun removeByIdAndName(id:kotlin.String,name:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Boolean>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			"name" to "${name?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Boolean> = httpClient.post {
				    url("/api/file/removeByIdAndName?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("upload")
	fun upload(file:com.jingfangpai.common.orm.mapping.File, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.File>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.File> = httpClient.post {
				    url("/api/file/upload?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.File.serializer(),file), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("uploadFromCkeditor")
	fun uploadFromCkeditor(entityType:kotlin.String,entityId:kotlin.String, okCallback: (result:com.jingfangpai.file.model.CkEditorFileUploadResponse) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"entityType" to "${entityType?:""}",
			"entityId" to "${entityId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.file.model.CkEditorFileUploadResponse = httpClient.post {
				    url("/api/file/upload/ckeditor?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
